var map = {
	"./de.json": "db06",
	"./en.json": "d782",
	"./es.json": "3f01",
	"./fr.json": "ff8f",
	"./pt.json": "415d",
	"./ru.json": "1a6d",
	"./uk.json": "a5d0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3e8d";